export const FETCH_PLACES = "FETCH_PLACES";
export const ADD_PLACE = "ADD_PLACE";
export const REMOVE_PLACE = "REMOVE_PLACE";
export const UPDATE_PATH = "UPDATE_PATH";
export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";
export const CHANGE_PROFILE = "CHANGE_PROFILE";

export function fetchPlaces() {
    return function(dispatch, getState) {
        let language = window.location.search? window.location.search.substr(10) : "hu";
        fetch("/" + language + "/places?_format=json").then(
            response => response.json()
        ).then(places => {
            places.forEach(place => {
                place.location = JSON.parse(place.location);
            });
            dispatch({
                type: FETCH_PLACES,
                places: places
            });
            const locations = places.map(place => {
               return [place.location.coordinates[0], place.location.coordinates[1]];
            });
            /*fetch("https://api.openrouteservice.org/v2/matrix/foot-hiking", {
                method: "post",
                headers: {"Content-Type": "application/json", "Authorization": "5b3ce3597851110001cf62487fbba2edb2924e5d8a6fbaa999271b74"},
                body: JSON.stringify({locations})
            }).then(
                response => response.json()
            ).then(json => {
                    console.log(json);
                }
            )*/}
        )
    }
}

export function addPlace(place, places) {
    updatePath(place, places);
    return {
        type: ADD_PLACE,
        place
    }
}

export function removePlace(place) {
    return {
        type: REMOVE_PLACE,
        place
    }
}

export function getSuggestions(input) {
    return function (dispatch) {
        fetch("/places?_format=json&keys=" + input).then(
            response => response.json()
        ).then(suggestionList => {
            dispatch({
                type: GET_SUGGESTIONS,
                suggestionList: suggestionList
            });
        });
    }
}

export function clearSuggestions() {
    return {
        type: CLEAR_SUGGESTIONS,
        suggestionList: []
    }
}

export function changeProfile(profile) {
    return {
        type: CHANGE_PROFILE,
        profile: profile
    }
}

export function updatePath(places, profile) {
    return function (dispatch) {
        if (places.length >= 2) {
            const coordinates = [];
            let segments = 0;
            const skipSegments = [];
            let previousPlaceContentTypeId;
            places.forEach(place => {
                coordinates.push([place.location.coordinates[0], place.location.coordinates[1]]);
                if (place.content_type_id === "port" && previousPlaceContentTypeId === "port")  {
                    skipSegments.push(segments);
                }
                segments++;
                previousPlaceContentTypeId = place.content_type_id;
            });
            fetch("https://api.openrouteservice.org/v2/directions/" + profile.profile + "/geojson", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "5b3ce3597851110001cf62487fbba2edb2924e5d8a6fbaa999271b74"
                },
                body: JSON.stringify({coordinates, skip_segments: skipSegments.length > 0 ? skipSegments : undefined, units: "km"})
            }).then(
                response => response.json()
            ).then(json => {
                dispatch({
                    type: UPDATE_PATH,
                    geometry: json.features[0].geometry,
                    properties: json.features[0].properties,
                    skipSegments: skipSegments
                })
            })
        } else {
            dispatch({
                type: UPDATE_PATH,
                geometry: {type: "LineString", coordinates: []}
            })
        }
    }
}
